"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _replace = _interopRequireDefault(require("lodash/replace"));
var _map = _interopRequireDefault(require("lodash/map"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _bootstrapModal = require("../../../modal/bootstrap-modal");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var ActivityModal = exports.ActivityModal = /*#__PURE__*/function (_React$Component) {
  _inherits(ActivityModal, _React$Component);
  function ActivityModal() {
    _classCallCheck(this, ActivityModal);
    return _callSuper(this, ActivityModal, arguments);
  }
  _createClass(ActivityModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        activities = _this$props.activities,
        showModal = _this$props.showModal,
        closeModal = _this$props.closeModal,
        onClickActivity = _this$props.onClickActivity;
      var useTypes = (0, _filter.default)(activities, function (a) {
        return (0, _replace.default)(a.use_subtype, ' ', '-').toLowerCase() === a.id;
      });
      var sortedActivities = (0, _sortBy.default)(useTypes, 'dropdown');
      return /*#__PURE__*/_react.default.createElement(_bootstrapModal.BootstrapModal, {
        showModal: showModal,
        modalSize: "sm-size",
        modalClass: "activity-modal",
        onClose: closeModal,
        header: /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "search.activity_modal.popular_activities",
          defaultMessage: "Popular Activities"
        })),
        body: /*#__PURE__*/_react.default.createElement("div", {
          className: "container-fluid"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-12"
        }, /*#__PURE__*/_react.default.createElement("ul", {
          style: {
            listStyle: 'none',
            paddingLeft: 0
          }
        }, (0, _map.default)(sortedActivities, function (act) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: act.id,
            className: "col-xs-12 col-sm-6"
          }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
            className: "btn btn-link remove-click-styling",
            onClick: function onClick(e) {
              onClickActivity(e, closeModal);
            },
            "data-value": act.id
          }, act.dropdown)));
        })))))
      });
    }
  }]);
  return ActivityModal;
}(_react.default.Component);
ActivityModal.propTypes = {
  activities: _propTypes.default.array.isRequired,
  showModal: _propTypes.default.bool,
  closeModal: _propTypes.default.func,
  onClickActivity: _propTypes.default.func
};